import { Provider } from '@angular/core';
import {
  DomWidgetFactoryService,
  JsxgraphService,
  JsxgraphThemeService,
  JsxgraphWidgetFactoryService,
  WIDGET_FACTORY,
  WidgetFactory,
  WidgetOrchestratorService,
} from '@examdojo/core/widget';
import { registerDomWidgets, registerJsxgraphWidgets } from './registry';

/**
 * Provider for JSXGraph widget factory with automatic widget registration.
 */
export function provideJsxgraphWidgets(): Provider[] {
  return [
    JsxgraphService,
    JsxgraphThemeService,
    JsxgraphWidgetFactoryService,
    {
      provide: WIDGET_FACTORY,
      useFactory: (factory: JsxgraphWidgetFactoryService): WidgetFactory => {
        registerJsxgraphWidgets(factory);
        return factory;
      },
      deps: [JsxgraphWidgetFactoryService],
      multi: true,
    },
  ];
}

/**
 * Provider for DOM-based widget factory with automatic widget registration.
 */
export function provideDomWidgets(): Provider[] {
  return [
    DomWidgetFactoryService,
    {
      provide: WIDGET_FACTORY,
      useFactory: (factory: DomWidgetFactoryService): WidgetFactory => {
        registerDomWidgets(factory);
        return factory;
      },
      deps: [DomWidgetFactoryService],
      multi: true,
    },
  ];
}

/**
 * Provides all widget factories and the orchestrator.
 * Single entry point — consumers don't need to know which frameworks exist.
 *
 * @example
 * ```ts
 * @Component({
 *   providers: [provideWidgets()]
 * })
 * ```
 */
export function provideWidgets(): Provider[] {
  return [...provideJsxgraphWidgets(), ...provideDomWidgets(), WidgetOrchestratorService];
}
